@if (data(); as msg) {
    Added <project-item [project]="msg.project" />
}
 